import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import { ProductCarousel } from '../Product';
import { ItemTileBase } from './ItemTileBase';

export const ItemTileCarouselComponent = ({ item, itemSearch, ...props }) => {
    return (
        <ItemTileBase item={item} itemSearch={itemSearch} {...props}>
            {productProps => <ProductCarousel {...productProps} item={item} />}
        </ItemTileBase>
    );
};

ItemTileCarouselComponent.propTypes = {
    item: PropTypes.object,
    itemSearch: PropTypes.object,
};

export const ItemTileCarousel = createFragmentContainer(ItemTileCarouselComponent, {
    viewer: graphql`
        fragment ItemTileCarousel_viewer on Viewer
        @argumentDefinitions(
            fetchRegionalInfo: { type: "Boolean", defaultValue: false }
            userZipCode: { type: "String", defaultValue: "" }
            userCountryCode: { type: "String", defaultValue: "" }
        ) {
            ...ItemTileBase_viewer
            @arguments(
                fetchRegionalInfo: $fetchRegionalInfo
                userZipCode: $userZipCode
                userCountryCode: $userCountryCode
            )
        }
    `,
    itemSearch: graphql`
        fragment ItemTileCarousel_itemSearch on ItemSearchQueryConnection {
            ...ItemTileBase_itemSearch
        }
    `,
    item: graphql`
        fragment ItemTileCarousel_item on Item
        @argumentDefinitions(
            isTrade: { type: "Boolean", defaultValue: false }
            showSeller: { type: "Boolean", defaultValue: false }
            pageDisplayEnum: { type: "PageDisplayEnum", defaultValue: searchAndBrowse }
            showCreatorLinksQuicklook: { type: "Boolean", defaultValue: false }
            buyerId: { type: "String", defaultValue: "" }
            fetchShippingCostInfo: { type: "Boolean", defaultValue: false }
        ) {
            ...ItemTileBase_item
            @arguments(
                showSeller: $showSeller
                isTrade: $isTrade
                pageDisplayEnum: $pageDisplayEnum
                showCreatorLinksQuicklook: $showCreatorLinksQuicklook
                buyerId: $buyerId
                fetchShippingCostInfo: $fetchShippingCostInfo
            )
            ...ProductCarousel_item
        }
    `,
});
